<div class='full-form style-1'>
  @if (datasetACS.loading.value || !mapReady) {
    <mat-progress-bar class='mt-24 mb-24' mode="indeterminate"></mat-progress-bar>
  }
  @if (savedCoords) {
    <p>Coordinate salvate: {{savedCoords.lat}}, {{savedCoords.lng}}</p>
  }
  @if (!savedCoords || (lat != savedCoords.lat || lng != savedCoords.lng)) {
    <p>Nuove coordinate: {{this.lat}}, {{this.lng}}</p>
  }
  @if (selectedPositionInfo && (!this.markers || !this.markers.length)) {
    <p>
      Nuovo indirizzo: {{selectedPositionInfo.formatted_address}}
    </p>
  }
  <div class="mb-16 fx-row fx-justify-start fx-items-center" style="gap: 16px">
    <mat-form-field class="fx-flex">
      <input matInput placeholder="Cerca luogo ..." [formControl]='searchTextFormControl'>
      @if (geosearching) {
        <mat-spinner diameter="20" matSuffix></mat-spinner>
      }
    </mat-form-field>
    <button mat-flat-button color='accent' (click)='search()'>
      Cerca
    </button>
  </div>

  @if (apiLoaded) {
    <google-map
      #gmap
      width="100%"
      height="400px"
      [center]="mapCenter"
      [zoom]="zoom"
      [options]="mapOptions"
      (mapInitialized)="mapReady.next(true)"
      (mapClick)="mapClicked($event)">
      @for (m of markers; track m; let i = $index) {
        <map-marker
          #markerRef="mapMarker"
          [position]="m.position"
          [options]="m.options"
          (mapClick)="clickedMarker(markerRef, m)"
          (mapDragend)="markerDragEnd(m, $event)">
        </map-marker>
      }
      <map-info-window><strong>{{ infoContent }}</strong></map-info-window>
    </google-map>
  }

  @if (canEdit) {
    <div class="mt-24 mb-24 fx-row fx-justify-end fx-items-center" style="gap: 10px">
      @if (savedCoords) {
        <button [disabled]='lat == savedCoords.lat && lng == savedCoords.lng' mat-flat-button (click)='resetPosition()'>Annulla modifiche</button>
      }
      <button color='accent' [disabled]='datasetACS.loading.value' mat-flat-button (click)='onSave()'>
        @if (!datasetACS.loading.value) {
          <span>{{ (hasNext ? "Salva e vai avanti" : "Salva") | translate }}</span>
        }
        @if (datasetACS.loading.value) {
          <span>{{'Azione in corso...' | translate}}</span>
        }
      </button>
    </div>
  }
</div>